module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "center": _vm.currentPlace,
      "zoom": _vm.localZoom
    },
    on: {
      "center_changer": function($event) {
        _vm.$emit('on-center-changed', $event)
      }
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "clickable": true,
        "position": m.position
      },
      on: {
        "click": function($event) {
          _vm.selectedMarker(m)
        }
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cc930c0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mapComponent.vue
// module id = 670
// module chunks = 0 32